import { createContext, useContext } from "react";

export const EnrollmentContext = createContext();

export const useEnrollmentInfo = () => {
    return useContext(EnrollmentContext);
};